module.exports = __webpack_public_path__ + "static/organizacja.678e8550.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/OfferSection/organizacja.jpg
// module id = 648
// module chunks = 18089617347968